export enum SmartyCubeStorageKeys {
	DATA_GRID_PAGE_NUM = 'dg_page_num',
	DEMO_USER_DASHBOARD = 'demo_user_dashboard',
	DEMO_USER_REPORT_META_DATA = 'demo_user_report_meta_data',
	DEMO_USER_REPORT_GENERAL_SETTINGS = 'demo_user_report_general_settings',
	USERS_SHOWN_INTERACTIVE_DEMO = 'users_shown_interactive_demo',
	THEME = 'theme',
}
